// Copyright (c) 2023, Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const DeviceFieldWrapper = styled.li`
  flex: 1;  
  flex-wrap: wrap;
  
  .flat-radios {
    padding-left: 0.5em;
    margin-bottom: 0.25em;
    
    > .radio-group {
      display: grid;
      grid-template-columns: 1fr 1fr;
      max-width: initial;
    }
  }

  .path-db-search-section & .labeled-input {
    width: calc(100% - 95px);
  }
  
  .lookup-trigger-icon {
    margin: 0.05em 0 0 0.5em;
  }
`
